/**
 * 智能分析：智能预警（司机月度打款预警） / 智能报表
 * 后端接口：ntocc-tms-api/smartAnalysis
 */
import request from "@/utils/request";

// 司机月度打款预警
export function driverRemitWarning(query) {
  return request({
    url: "/ntocc-tms-api/smartAnalysis/warning/driverRemit",
    method: "get",
    params: query
  });
}

// 智能报表（自然语言查询审核量）
export function smartReport(query) {
  return request({
    url: "/ntocc-tms-api/smartAnalysis/report/smart",
    method: "get",
    params: query
  });
}

// 智能报表-平台报表
export function platformReport(query) {
  return request({
    url: "/ntocc-tms-api/smartAnalysis/report/platform",
    method: "get",
    params: query
  });
}

// 智能报表-审核报表导出 CSV（响应为 Blob）
export function reportExport(query) {
  return request({
    url: "/ntocc-tms-api/smartAnalysis/report/export",
    method: "get",
    params: query,
    responseType: "blob"
  });
}

// 智能报表-平台报表导出 CSV（响应为 Blob）
export function platformReportExport(query) {
  return request({
    url: "/ntocc-tms-api/smartAnalysis/report/platform/export",
    method: "get",
    params: query,
    responseType: "blob"
  });
}
